import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";
import {Site} from "../../../models/support.model";

@Component({
	templateUrl: './set_multilang_clone.component.html'
})
export class SetMultilangCloneModalComponent extends BaseSupportModalComponent {
	siteId: string;
	multilangParentId: string;
	siblings: Site[] = [];

	async ok() {
		console.log('multilangParentId', this.multilangParentId, this.multilangParentId.length);
		
		if(this.multilangParentId === '') {
			console.log('unsetMultilangParentId');
			await this.supportService.unsetMultilangParentId(this.siteId, this.spreader.base.comment).toPromise();
		} else {
			console.log('setMultilangParentId');
			await this.supportService.setMultilangParentId(this.siteId, this.multilangParentId, this.spreader.base.comment).toPromise();	
		}		

		this.execute();
	}
}
